export default __webpack_public_path__ + "images/avatar-background.svg";